<div class="col-md-12">
    <h3 class="">Assign Contract</h3>  
    <hr style="margin: 0;border: lightgray solid 0.5px; ">
    <br />
    <div class="panel panel-primary">
      <div class="panel-heading">Add/Remove Contract</div>
      <div class="panel-body">
    <div class="form">
      <form name="form" (ngSubmit)="f.form.valid && OnSubmit()" #f="ngForm"  novalidate>
    <div class="form-group row">
    <label for="supplierid" class="col-sm-2 col-form-label">SupplierID</label>
    <div class="col-sm-4">        
        <input  id="supplierid" placeholder="Supplier ID"  (selectItem)="selectedItem($event)" name ="SupplierID" type="text" class="form-control" [(ngModel)]="SupplierID" [ngbTypeahead]="searchUserCAI" #SuppID="ngModel" [ngClass]="{ 'is-invalid': f.submitted && SuppID.invalid }" required/> 
        <div *ngIf="f.submitted && SuppID.invalid" class="invalid-feedback invalid-display">
                <div *ngIf="SuppID.errors?.['required']">*SupplierID is required</div>
        </div> 
    </div>
    
    </div>
    <div class="form-group row">
    <label for="Contract ID" class="col-sm-2 col-form-label">ContractID</label> 
    <div class="col-sm-4">
      <input type="text" [(ngModel)]="ContractID" maxlength="50"   class="form-control" id="Contract ID" placeholder="ContractID" name ="ContractID" #ConID="ngModel"
      [ngClass]="{ 'is-invalid': f.submitted && ConID.invalid }" required>
    <div *ngIf="f.submitted && ConID.invalid" class="invalid-feedback invalid-display">
      <div *ngIf="ConID.errors?.['required']">*ContractID is required</div>
    </div>
    </div>
    </div>
    
    <div class="form-group row">
        <label for="ConDesc" class="col-sm-2 col-form-label">Contract Description</label>
        <div class="col-sm-4">
                <input type="text" class="form-control" maxlength="500"  [(ngModel)]="ContractDescription" id="ConDesc" placeholder="Contract Description" name ="ConDesc" #ContractDesc="ngModel"
                [ngClass]="{ 'is-invalid': f.submitted && ContractDesc.invalid }" required>
            <div *ngIf="f.submitted && ContractDesc.invalid" class="invalid-feedback invalid-display">
                <div *ngIf="ContractDesc.errors?.['required']">*Contract Description is required</div>
        </div>
        </div>
        </div> 
        
    
        <div class="form-group row">
            <div class="col-sm-2">
                </div>
            <div class="col-sm-2 ">
            <button class="btn btn-primary " >{{SaveUpdate}}</button> 
            </div>
            <div class="col-sm-2 ">
                <button class="btn btn-primary" style="text-align:right" (click)="initForm()" >Reset Form</button> 
                </div>
            </div>
    
    
          </form>      </div>
    </div>
    </div>
    <div class="clearfix"></div>
      <br /> <br />
      <table class="table table-bordered">
        <thead>
          <tr>
            <th scope="col">SupplierID</th>
            <th scope="col">Supplier Name</th>
            <th scope="col">ContractID</th>
            <th scope="col">Contract Description</th>          
            <th colspan="2" scope="col" >Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of viewMasterList">
            <td>{{ item.SupplierID }}</td>
            <td>{{ item.SupplierName }}</td>
            <td>{{ item.ContractId }}</td>
            <td>{{ item.ContractDescription }}</td>          
            <td colspan="2">
              <a (click) = "deleteConfirm(item)" class="btn btn-danger">Delete</a>
              <a  style="margin-left: 20px;" (click) = "editContract(item)" class="btn btn-primary">Edit</a>
            </td>
            
          </tr>
        </tbody>
      </table>
    </div>
    
    